<template>
    <figure class="flex flex-col gap-4">
        <div class="flex items-center justify-center gap-[10px]">
            <v-icon icon="connect-without-contact"></v-icon>
            <div class="text-body-medium-button text-black-78">
                Kontaktni podatki
            </div>
        </div>
        <ul class="flex flex-col gap-8">
            <li class="flex gap-[10px]">
                <div class="w-1/3">
                    <v-select
                        class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                        :options="phonePrefixOptions"
                        placeholder="Država"
                        v-model="phoneOption"
                        label="name"
                        @search:focus="onFocus"
                        @search:blur="onBlur"
                        ref="phone_prefix_options"
                        id="phone_prefix_options"
                        :name="'phone_prefix_options'"
                        :disabled="true"
                    >
                        <template v-slot:no-options>
                            Za ta iskalni niz ni zadetkov.
                        </template>
                    </v-select>
                    <input
                        type="hidden"
                        name="phone_prefix"
                        :value="phoneOption == null ? '' : phoneOption.dial_code"
                    />
                    <input
                        type="hidden"
                        name="phone_country"
                        :value="phoneOption == null ? '' : phoneOption.code"
                    />
                    <template v-if="validationErrors.phone_prefix">
                        <label class="small-text-medium text-red-500">
                            {{ validationErrors.phone_prefix[0] ?? "" }}
                        </label>
                    </template>
                </div>
                <div class="w-2/3">
                    <v-form-input
                        id="phone"
                        label="Telefonska številka"
                        type="text"
                        :disabled="true"
                        required="required"
                        name="phone"
                        :value="user.phone"
                    ></v-form-input>
                    <template v-if="validationErrors.phone">
                        <label class="small-text-medium text-red-500">
                            {{ validationErrors.phone[0] ?? "" }}
                        </label>
                    </template>
                </div>
            </li>
            <li>
                <v-form-input
                    id="email"
                    label="Elektronski naslov"
                    type="text"
                    name="email"
                    :disabled="true"
                    :value="user.email"
                ></v-form-input>
                <template v-if="validationErrors.email">
                    <label class="small-text-medium text-red-500">
                        {{ validationErrors.email[0] ?? "" }}
                    </label>
                </template>
            </li>
        </ul>
        <div class="text-body-medium-button text-black-78">
            Kontaktni podatki so zaklenjeni. Za spremembo nam pišite na info@n24.si.
        </div>
    </figure>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        customerFormEnums: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
        },
        phonePrefixOptions: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            phoneOption: null,
        };
    },
    mounted() {
        this.phonePrefixOptions.forEach((element) => {
            if(element.dial_code == this.user.phone_prefix) {
                this.phoneOption = element
            }
        })
    },
    methods: {
        onFocus() {
            // Implement your onFocus function
        },
        onBlur() {
            // Implement your onBlur function
        },
    },
};
</script>
